import { connect } from 'react-redux';
import { REF_NAME, REF_PATH } from './Const';
import { getSimpleListWrapper } from '../SimpleWrapper';
import SimpleNameDisplayWrapper from '../SimpleNameDisplayWrapper';

class PackingNameDisplayWrapper extends SimpleNameDisplayWrapper {
  loadData() {
    getSimpleListWrapper(REF_NAME, REF_PATH);
  }
}

export default connect((state) => ({
  itemList: state.getIn(['references', 'simple', REF_PATH]),
})
)(PackingNameDisplayWrapper);
